(function ($) {

    $(document).ready(function () {

        if ($('.section-isotope-resources').length) {

            var $grid = $(this).find('.content');

            $grid.isotope({
                itemSelector: '.item',
                layoutMode: 'fitRows'
            });


            $('select.selectpicker').select2({
                minimumResultsForSearch: Infinity
            });

            $(this).find('.selectpicker').change(function () {

                var filter = $(this).find("option:selected").attr('value');

                $grid.isotope({filter: '.' + filter});


                $grid.find('.item a').each(function () {
                    if ($(this).hasClass(filter)) {
                        $(this).show();
                    } else {
                        $(this).hide();
                    }
                });

                if (filter == 'item') {
                    $grid.find('.item a').show();
                }

            });


            $('.section-isotope-resources a.videos').click(function (e) {
                e.preventDefault();

                console.log('video');

                var $videoModal = $('.video-modal', $(this).parents('.links'));

                $videoModal.addClass('shown');
            });

            /*$('.video-modal').click(function (e) {
                var $target = $(e.target);

                if ($target.hasClass('video-modal'))
                    $(this).removeClass('shown');
            });*/

            /*$(document).mouseup(function(e){
                var container = $(".video-modal.shown iframe");

                // If the target of the click isn't the container
                if(!container.is(e.target) && container.has(e.target).length === 0){
                    console.log('hello');
                    $(".video-modal.shown iframe").removeClass('shown');
                }
            });*/

        }

    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/isotope-resources.js